import { useQuery, useMutation } from "@tanstack/react-query"
import {
  getEducationalVideo,
  logEducationalVideoEvent,
} from "../api/educationalVideos"

export const useEducationalVideo = (uuid) =>
  useQuery({
    queryKey: ["educational-video", uuid],
    queryFn: () => getEducationalVideo(uuid),
    retry: false,
    enabled: !!uuid,
    select: (data) => ({
      ...data?.data,
      videos: data?.data?.videos || [],
    }),
  })

// Tracking must never interrupt a patient reading their report: failures are
// swallowed and nothing on the page depends on the result.
export const useLogEducationalVideoEvent = () =>
  useMutation({
    mutationFn: logEducationalVideoEvent,
    retry: false,
    onError: (error) => {
      console.warn("Failed to log educational video event:", error)
    },
  })
